// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__biBIp","balanceDisclaimer":"posDashboard_balanceDisclaimer__36flr"};